import React from 'react';
import { Heart, Star, Quote, MapPin, Calendar } from 'lucide-react';

interface Testimonial {
  id: number;
  coupleName: string;
  date: string;
  rating: number;
  comment: string;
  specialNote?: string;
}

const Testimonials: React.FC = () => {
  const testimonials: Testimonial[] = [
    {
      id: 1,
      coupleName: "田中 美咲様・健太郎様",
      date: "2024年11月",
      rating: 5,
      comment: "ゲストの皆さんが撮影してくれた\n写真をすべて見ることができて、\n私たちが知らない素敵な瞬間も\nたくさん発見できました。\nリアルタイムでスクリーンに映る\n写真を見て、会場が一体となって\n感動を共有できたのが\n本当に素晴らしかったです。",
      specialNote: "写真数: 280枚、参加ゲスト: 85名"
    },
    {
      id: 2,
      coupleName: "佐藤 綾香様・大輔様",
      date: "2024年12月",
      rating: 5,
      comment: "操作が簡単で年配の方もスムーズに写真を投稿できました。\nコメント機能で皆さんからの\n温かいメッセージをいただき、\n式後も何度も見返しています。\n導入して本当に良かったです",
      specialNote: "写真数: 420枚、参加ゲスト: 120名"
    },
    {
      id: 3,
      coupleName: "山田 恵理様・翔太様",
      date: "2024年10月",
      rating: 5,
      comment: "デザインがとても上品で美しく、\n式場の雰囲気にぴったりでした。モデレーション機能のおかげ\nで安心して利用できました。\n写真だけでなくゲストからの\nメッセージも宝物になりました。",
      specialNote: "写真数: 350枚、参加ゲスト: 95名"
    },
    // {
    //   id: 4,
    //   coupleName: "鈴木 麻衣様・雅彦様",
    //   venue: "ホテルオークラ神戸",
    //   date: "2024年9月",
    //   rating: 5,
    //   comment: "挙式中もリアルタイムで写真が共有されるので、全ての瞬間を逃すことなく記録できました。式場スタッフの方々も使いやすいと言ってくださり、進行もスムーズでした。ゲストの皆様にも大変好評でした。",
    //   specialNote: "写真数: 310枚、参加ゲスト: 78名"
    // }
  ];

  const statistics = {
    totalVenues: 300,
    totalPhotos: 50000,
    totalGuests: 25000,
    satisfaction: 98
  };

  const renderStars = (rating: number) => {
    return Array.from({ length: 5 }, (_, index) => (
      <Star 
        key={index} 
        className={`star ${index < rating ? 'filled' : ''}`} 
        size={20}
      />
    ));
  };

  return (
    <section className="testimonials-section">
      <div className="section-header">
        <div className="title-decoration">
          <div className="decoration-line"></div>
          <Heart className="section-heart" />
          <div className="decoration-line"></div>
        </div>
        <p className="testimonials-subtitle">
          Photo Memorial をご利用いただいた新郎新婦様からの実際の感想をご紹介します
        </p>
      </div>

      <div className="testimonials-grid">
        {testimonials.map((testimonial) => (
          <div key={testimonial.id} className="testimonial-card">
            <div className="testimonial-quote">
              <Quote className="quote-icon" />
            </div>
            
            <div className="testimonial-stars">
              {renderStars(testimonial.rating)}
            </div>
            
            <p className="testimonial-text">
              {testimonial.comment}
            </p>
            
            <div className="testimonial-author">
              <div className="author-info">
                <h4 className="author-name">{testimonial.coupleName}</h4>
                <div className="author-details">
                  <div className="author-date">
                    <Calendar size={14} />
                    {testimonial.date} 結婚式
                  </div>
                </div>
                {testimonial.specialNote && (
                  <div className="author-note">{testimonial.specialNote}</div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="trust-indicators">
        <h3 className="trust-title">選ばれる理由</h3>
        <div className="trust-points">
          <div className="trust-point">
            <div className="trust-icon">📸</div>
            <div className="trust-content">
              <h4>思い出をその場で共有</h4>
              <p>その場で映るライブ感が<br />楽しめます</p>
            </div>
          </div>
          <div className="trust-point">
            <div className="trust-icon">🛡️</div>
            <div className="trust-content">
              <h4>セキュリティも安心</h4>
              <p>投稿写真はモデレーション機能<br />や自動削除機能で管理可能</p>
            </div>
          </div>
          <div className="trust-point">
            <div className="trust-icon">⚡</div>
            <div className="trust-content">
              <h4>簡単導入</h4>
              <p>設備不要・QRコード配置のみで< br />即日利用可能</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
